import PropTypes from 'prop-types';

export const AppointmentInformation = ({ listItem }) => (
  <ul>
    <li>
      Please aim to arrive
      <strong> 10 minutes before </strong>
      your appointment time
    </li>
    <li>
      As this is a skincare/make-up appointment, you may find it easier to come to the appointment
      without any products on as we may remove them during your appointment
    </li>
    <li>
      &quot;The Beauty Society&quot; is located on the shopfloor, your appointment is not private,
      but is discreet and one-to-one with a Beauty Guide
    </li>
    <li>
      If your booking is for someone else, we&apos;ll call you before their appointment to take
      payment
    </li>
    <li>
      <strong>Please note:&nbsp;</strong>
      Your treatment options may be affected by allergies, medical conditions or pregnancy. If you
      have any concerns regarding this, please contact your shop on the phone number shown above
    </li>
    {listItem}
  </ul>
);

AppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};
